import React, { FC } from 'react';
import { merge } from 'lodash';
import { Modal, ModalProps } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

import { CloseIcon } from './components/CloseIcon';

export interface Props extends ModalProps {
  children: React.ReactNode;
}

const ResponsiveModal: FC<Props> = props => {
  const { center = true, styles, children, ...rest } = props;

  const defaultStyles = {
    root: {
      // необходимо, чтобы перебить z-index шапки в отелях
      zIndex: 11000,
    },
    overlay: {
      padding: 0,
      background: 'rgba(145,148,153,.5)',
      // необходимо, чтобы перебить z-index шапки в отелях
      zIndex: 11000,
    },
    modal: {
      overflow: 'visible',
      margin: 'auto',
    },
    closeButton: {
      top: '16px',
      right: '16px',
      color: '#919499',
      outline: 'none',
    },
  };
  const combinedStyles = merge(defaultStyles, styles);

  return (
    <Modal
      center={center}
      closeIcon={<CloseIcon />}
      {...rest}
      styles={combinedStyles}
    >
      {children}
    </Modal>
  );
};

export default ResponsiveModal;
